'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultMessage = undefined;
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var _getErrorMessage = require('./get-error-message');
var _getErrorMessage2 = _interopRequireDefault(_getErrorMessage);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var defaultMessage = exports.defaultMessage = 'You must enter a number in this field.';
exports.default = function () {
  var errorMessage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultMessage;
  return function (value, values) {
    switch (typeof value === 'undefined' ? 'undefined' : _typeof(value)) {
      case 'string':
        return /^(\+|-)?(\d+)?(\.?\d+){1}$/.test(value) ? '' : (0, _getErrorMessage2.default)(errorMessage, {
          value: value
        });
      case 'number':
        return '';
      default:
        return (0, _getErrorMessage2.default)(errorMessage, {
          value: value
        });
    }
  };
};